var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHappyEmoji(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FFCC4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 18.6675C12.78 18.6675 10.6431 18.2924 8.00043 17.7786C7.39688 17.6622 6.22266 17.7786 6.22266 19.5564C6.22266 23.1119 10.3071 27.5564 16.0004 27.5564C21.6929 27.5564 25.7782 23.1119 25.7782 19.5564C25.7782 17.7786 24.604 17.6613 24.0004 17.7786C21.3578 18.2924 19.2209 18.6675 16.0004 18.6675Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19.5547C8 19.5547 10.6667 20.4436 16 20.4436C21.3333 20.4436 24 19.5547 24 19.5547C24 19.5547 22.2222 23.1102 16 23.1102C9.77778 23.1102 8 19.5547 8 19.5547Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6675 15.1128C11.8948 15.1128 12.8898 13.72 12.8898 12.0017C12.8898 10.2835 11.8948 8.89062 10.6675 8.89062C9.44024 8.89062 8.44531 10.2835 8.44531 12.0017C8.44531 13.72 9.44024 15.1128 10.6675 15.1128Z",
    fill: "#664500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3336 15.1128C22.5608 15.1128 23.5558 13.72 23.5558 12.0017C23.5558 10.2835 22.5608 8.89062 21.3336 8.89062C20.1063 8.89062 19.1113 10.2835 19.1113 12.0017C19.1113 13.72 20.1063 15.1128 21.3336 15.1128Z",
    fill: "#664500"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyEmoji);
export default __webpack_public_path__ + "static/media/happy_emoji.c69ac04fa882ff593a00945b9c1d5a03.svg";
export { ForwardRef as ReactComponent };